import { type JSXElementConstructor, type ReactElement } from "react";
import * as b from "fp-ts/lib/boolean";
import * as O from "fp-ts/lib/Option";

export type ReactElementOrEmpty = ReactElement | null | undefined;

// FU React... Use () => null instead of constNull so that react will use the name Empty instead of anonymous in profiler (shadow DOM)
export const Empty: JSXElementConstructor<object> = (): null => null;
/** A thunk that always returns null so that any usages of this will not appear in the shadow DOM */
export const constEmpty = (): ReactElementOrEmpty => null;

export const toEmpty: (ma: O.Option<ReactElementOrEmpty>) => ReactElementOrEmpty = O.getOrElse((): ReactElementOrEmpty => null);

export const mapOrEmpty = <A,>(fa: (a: A) => ReactElementOrEmpty): (ma: O.Option<A>) => ReactElementOrEmpty => O.fold(constEmpty, fa);
export const noneOrEmpty = <A,>(fa: () => ReactElementOrEmpty): (ma: O.Option<A>) => ReactElementOrEmpty => O.fold(fa, constEmpty);
/** @knipignore */
export const mapWithKeyOrEmpty = <A,>(fa: (a: A, key: string) => ReactElementOrEmpty, k: string): (ma: O.Option<A>) => ReactElementOrEmpty => O.fold(constEmpty, _ => fa(_, k));

export const trueOrEmpty = (component: ReactElementOrEmpty): (value: boolean) => ReactElementOrEmpty => b.fold(constEmpty, () => component);
export const falseOrEmpty = (component: ReactElementOrEmpty): (value: boolean) => ReactElementOrEmpty => b.fold(() => component, constEmpty);
